
import React, { Component } from "react";
import axios from "axios";

import HeroItem from "./HeroItem";

export class HeroBanners extends Component {
    state = {
        heros: [],
        
    };
    
    componentDidMount() {
    axios
        .get("https://obrien365.com/ob-wp/wp-json/wp/v2/heros/")
        .then((res) =>
        this.setState({
            heros: res.data,
            
        })
        )
        .catch((err) => console.log(err));
    }
    
      render() {
        const { heros } = this.state;
        
          return (
            <div className="App">
              
              {heros.map((hero) => (
                  //@ts-ignore
                <HeroItem key={hero.id} hero={hero} />
              ))}
              
            </div>
          );
        
      }
}
export default HeroBanners;